import { API_URL } from "@/config/constants";
import axios from "axios";
import { ISkill } from "../skills/skills.types";
import {
    IIndustry,
    IIndustryCreate,
    IIndustryUpdate,
    IIndustryWithPolicyTypes,
} from "./industries.types";

const API = `${API_URL}/industries`;

export const getIndustries = async () => {
    const result = await axios.get<IIndustryWithPolicyTypes[]>(API);
    return result.data;
};

export const getIndustryById = async (id: number) => {
    const result = await axios.get<IIndustryWithPolicyTypes>(`${API}/${id}`);
    return result.data;
};

export const createIndustry = async (data: IIndustryCreate) => {
    const result = await axios.post<IIndustry>(API, data);
    return result.data;
};

export const updateIndustry = async (id: number, data: IIndustryUpdate) => {
    const result = await axios.put<IIndustry>(`${API}/${id}`, data);
    return result.data;
};

export const deleteIndustry = async (id: number) => {
    const result = await axios.delete(`${API}/${id}`);
    return result.data;
};

export const generateIndustrySkill = async (id: number) => {
    const result = await axios.post<ISkill>(`${API}/${id}/generate-skill`);
    return result.data;
};
